'use client';

import React, { useCallback, useMemo } from 'react';
import { Button } from '@benzinga/core-ui';
import { useEdgeCheckoutMode } from '@benzinga/user-context';
import { useEdgePaywallCheckoutModal } from '@benzinga/edge';

type EdgeRankingPaywallButtonProps = {
  adType: string;
  checkoutAd: string;
  checkoutUrl?: string;
  className?: string;
  label: string;
};

export const EdgeRankingPaywallButton: React.FC<EdgeRankingPaywallButtonProps> = ({
  adType,
  checkoutAd,
  checkoutUrl,
  className,
  label,
}) => {
  const { checkoutMode, isCheckoutModeReady } = useEdgeCheckoutMode();

  const checkoutParams = useMemo(
    () => ({
      ad: checkoutAd,
      adType,
      campaign: 'ranking',
    }),
    [adType, checkoutAd],
  );

  const { handleCheckoutClick, usesModalCheckout } = useEdgePaywallCheckoutModal({
    checkoutMode,
    checkoutParams,
    checkoutType: 'ranking_checkout_iframe',
    checkoutUrl: checkoutUrl ?? '',
    isCheckoutModeReady,
    paywallId: checkoutAd,
  });

  const usesLinkCheckout = !usesModalCheckout && Boolean(checkoutUrl);

  const handleLinkCheckoutClick = useCallback(
    (event: React.MouseEvent) => {
      if (!isCheckoutModeReady) return;
      event.preventDefault();
      handleCheckoutClick();
    },
    [handleCheckoutClick, isCheckoutModeReady],
  );

  return (
    <Button
      as={usesLinkCheckout ? 'a' : undefined}
      className={className}
      href={usesLinkCheckout ? checkoutUrl : undefined}
      onClick={usesLinkCheckout ? handleLinkCheckoutClick : handleCheckoutClick}
      target={usesLinkCheckout ? '_blank' : undefined}
      variant="flat-blue"
    >
      {label}
    </Button>
  );
};
